import AdminPlanningReviews from './admin-planning-reviews'

export default AdminPlanningReviews
